"use strict";

import { LogHelper } from "com-gyf-webcore-loghelper";
import ProcessManager from "../../Common/Managers/ProcessManager";
/*Imports de distintos actions*/
import { SET_ENTIDAD_ID, LIMPIAR_RUTEO_ATLAS } from "../../Screens/ListadoParametros/actions/Actions"
import { SET_ENTIDAD_INSTANCIA_ID, NUEVA_ENTIDAD_INSTANCIA } from "../../Screens/VistaInstanciaParametro/actions/Actions";
import { LIMPIAR_ESTADO_ATLAS } from "../../Screens/NuevaInstanciaParametro/actions/Actions";

import {
    GET_INITIAL_DATA_ATLAS_SUCCESS
} from '../../Screens/Atlas/actions/atlas';
/**
 * Estado inicial.
 */
const initialState = {
    entidadId: undefined,
    entidadInstanciaId: undefined,
    programSelected: false,
    perfiles: 0,
    defaultProducto: null
};

/**
 * Reduce store.
 */
function atlas(state = initialState, action) {
    switch (action.type) {
        case SET_ENTIDAD_ID:
        case SET_ENTIDAD_INSTANCIA_ID: {
            /*Da igual por donde venga, tengo que conservar los ids*/
            return {
                ...state,
                ...action
            }
        }
        case NUEVA_ENTIDAD_INSTANCIA: {
            /*action: objeto formado por rutearNuevaInstancia (indica si tiene que rutear a la pantalla de nueva instancia parametro) y
            rutaNuevaInstancia (indica a donde tiene que hacer el redirect al momento de renderizar el componente)*/
            return {
                ...state,
                entidadInstanciaId: undefined,
                ...action
            };
        }
        case LIMPIAR_ESTADO_ATLAS: {
            /*Reseteo todo el state de atlas*/
            return {
                entidadId: state.entidadId,
                entidadInstanciaId: undefined
            }
        }
        case LIMPIAR_RUTEO_ATLAS: {
            /*A diferencia de LIMPIAR_ESTADO_ALTAS, en esta instancia tengo que mantener los ids de las entidades seleccionadas*/
            return {
                entidadId: state.entidadId,
                entidadInstanciaId: state.entidadInstanciaId
            }
        }
        case GET_INITIAL_DATA_ATLAS_SUCCESS:

            let menuUsuario = action.result.GET_MENU_BY_USUARIO_ID;
            let path = action.result.GET_USUARIO_INICIO[0] ? true : false;
            let productosCount = action.result.GET_PRODUCTO_USUARIO_LOGIN.length;

            let initialProduct = action.result.GET_PRODUCTO_USUARIO_LOGIN[0].ProductoId;
            let rowsPerProduct = action.result.GET_PRODUCTO_USUARIO_LOGIN.filter(
                x => x.ProductoId != initialProduct
            );   

            return {
                ...state,
                programSelected: path,
                productos: productosCount,
                defaultProducto: rowsPerProduct.length == 0 ? action.result.GET_PRODUCTO_USUARIO_LOGIN[0] : null,
            };
            break;
        default: {
            return {
                ...state
            };
        }
    }
}

export default atlas;


// WEBPACK FOOTER //
// ./Portico/Productos/Atlas/App/store/Reducers/Atlas.js